import React from 'react';
export function ShuffleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.293 3.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L18.586 8h-4.818a1 1 0 00-.67.257L3.67 16.743a1 1 0 11-1.338-1.486L5.949 12 2.331 8.744a1 1 0 011.338-1.486l3.775 3.397 4.317-3.885A3 3 0 0113.768 6h4.818l-1.293-1.293a1 1 0 010-1.414zM13.768 18a3 3 0 01-2.007-.77l-1.653-1.488a1.086 1.086 0 01-.038-.036l-1-1a1 1 0 111.414-1.414l.981.981 1.633 1.47a1 1 0 00.67.257h4.819l-1.294-1.294a1 1 0 011.414-1.414l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L18.585 18h-4.818z"
  }));
}